import type { FeatureFlag } from '@ps/web-core-enums';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';

const useFeature = (flag: FeatureFlag) => {
  const selector = useCallback((state) => select.feature.check(state, flag), [flag]);
  return useSelector(selector);
};

export default useFeature;
